import { createFileRoute, Link } from "@tanstack/react-router";

export const Route = createFileRoute("/privacy")({
  component: PrivacyPage,
});

function PrivacyPage() {
  return (
    <main className="mx-auto w-full max-w-2xl px-4 sm:px-5 py-8 prose prose-invert flex-1">
      <p className="text-xs text-[color:var(--color-fg-muted)] mb-2">
        <Link to="/" className="hover:underline">← back</Link>
      </p>
      <h1>Privacy policy</h1>
      <p>
        Bargain Radar is operated under the Australian Privacy Act 1988 and the
        13 Australian Privacy Principles (APPs). This page describes the personal
        information we collect, how we use it, and how to contact us about it.
      </p>

      <h2>Personal information we collect</h2>
      <ul>
        <li>Your email, display name, and a password hash, when you create an account.</li>
        <li>Your Google account email and display name, when you sign in with Google.</li>
        <li>Your display name, if you change it on the profile screen.</li>
        <li>Comment + vote activity, linked to your account.</li>
        <li>Price-alert targets and whether you found AI purchase advice helpful.</li>
      </ul>
      <p>
        Email passwords are stored only as a scrypt hash. We do not collect
        your date of birth, address, phone number, or payment details.
      </p>

      <h2>AI purchase advice</h2>
      <p>
        When you ask Jev, product details and recorded prices are sent through
        Cloudflare AI Gateway to TypeSafe AI. Your email and display name are not sent.
        The result is general shopping guidance, not financial advice.
      </p>

      <h2>What we do not log</h2>
      <ul>
        <li>We do not log IP addresses against user accounts beyond what's needed for short-term spam prevention (max 30 days).</li>
        <li>We do not log retailer querystrings (some of those carry tracking ids).</li>
        <li>We do not share your email with third parties.</li>
      </ul>

      <h2>Cookies</h2>
      <p>
        We use a single first-party HTTP-only cookie (<code>better-auth.session_token</code>)
        to keep you signed in for 7 days from your last activity. Sign out clears it server-side.
      </p>

      <h2>Takedown requests for scraped listings</h2>
      <p>
        See the <Link to="/scraper-policy">scraper policy</Link> for how we handle
        retailer takedown requests. We retain the requester email for 7 years (for
        audit) and then permanently null it from our database.
      </p>

      <h2>Your rights</h2>
      <p>
        Under APP 12 / 13 you can request a copy of any personal information we hold
        about you, and ask us to correct or delete it. Email
        <a href="mailto:privacy@bargainradar.com.au"> privacy@bargainradar.com.au</a>.
        We will respond within 30 days.
      </p>

      <h2>Contact</h2>
      <p>
        <a href="mailto:privacy@bargainradar.com.au">privacy@bargainradar.com.au</a>
      </p>
    </main>
  );
}
